// Design tokens for the Reporting 2.0 surface, matched to the FLANK 2.0
// (loveable) reference: orange accent, white cards on a light page, green/red
// deltas. Kept local to the page so it doesn't touch the global MUI theme.
export const COLORS = {
  primary: '#EA580C', // orange-600 — accent (active states, segmented control)
  primaryHover: '#C2410C',
  primaryBorder: '#F97316', // orange-500 — active control border
  primarySoft: '#FFF7ED', // orange-50 — active row/segment background
  green: '#16A34A',
  red: '#DC2626',
  text: '#111827',
  muted: '#6B7280',
  border: '#E5E7EB',
  card: '#FFFFFF',
  pageBg: '#F9FAFB',
  black: '#111827',
} as const;

// Card chrome shared by KPI / outcome / chart cards.
export const cardSx = {
  bgcolor: COLORS.card,
  border: `1px solid ${COLORS.border}`,
  borderRadius: '12px',
  boxShadow: 'none',
  // Every card keeps itself whole across a page break. Declared here rather
  // than as a class because ten card components spread `cardSx` and only two
  // carried the print hook — the real PDF put "Headline KPIs by Platform" alone
  // at the foot of one page with its table on the next (FB-005, Earl).
  '@media print': { breakInside: 'avoid' },
} as const;
